export const slideImages = [
  {
    img: "./assets/image-1.svg",
  },
  {
    img: "./assets/image-2.svg",
  },
  {
    img: "./assets/image-3.svg",
  },
  {
    img: "./assets/image-4.svg",
  },
  {
    img: "./assets/image-5.svg",
  },
  {
    img: "./assets/image-6.svg",
  },
  {
    img: "./assets/image-7.svg",
  },
];
